import { render, staticRenderFns } from "./EfectosPosibles.vue?vue&type=template&id=5fa0d0f0&"
import script from "./EfectosPosibles.vue?vue&type=script&lang=js&"
export * from "./EfectosPosibles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports